module.exports = __webpack_public_path__ + "igdc2024-ef275a75.webp";